import { coefficientsNavigation } from "./constants/menus";
import Sidebar from "@/components/layouts/Sidebar";
import { Outlet } from "react-router-dom";

export const SettingsMain = () => {
  return (
    <div className="flex h-svh  ">
      <Sidebar menu={coefficientsNavigation} hasTopMargin={true} />

      {/* Main content area */}
      <main className="flex-1 ml-36">
        <div className="sm:flex-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};
